<div class="direct-debit">
    <div class="main-title">
        <h1>{{ contents.homePage.header }}</h1>
        <h2>{{ contents.homePage.subHeader }}</h2>
    </div>
    <div class="content">
        <div class="which-card">
            <div class="title-wrapper">
                <h2>לאיזה כרטיס M_A_X להעביר את הוראות הקבע?</h2>
            </div>
            <app-carousel-direct-debit
                [cards]="destCards"
                [CardSelectedRef]="currentDestCard"
                (cardSelected)="cardSelected($event)"
            ></app-carousel-direct-debit>

            <div class="form-check-wrapper">
                <input
                    class="form-check-input"
                    [ngModel]="chkRegulations"
                    type="checkbox"
                    id="chkTerms"
                    (ngModelChange)="chkRegulationsChange()"
                />
                <label class="form-check-label" for="chkTerms">
                    <span>קראתי ואני מאשר/ת את</span>
                    <a (click)="openRegulation($event)" class="link" title=""> התנאים המשפטיים</a>
                    <span> להעברת הוראות הקבע</span>
                </label>
                <div class="error-wrapper">
                    <span class="err-msg" *ngIf="showErrorMessage">יש לאשר את תנאי השימוש</span>
                </div>
            </div>
           
                <div class="button-wrapper">
                    <div class="error-wrapper">
                        <span class="err-msg" *ngIf="showErrorNoSelectedCard">יש לבחור כרטיס לפני שנתקדם</span>
                    </div>
                    <a class="brand-button green-button" (click)="transferAllDirectDebits()" title=""
                        ><span>העבר את כל הוראות הקבע</span></a
                    >
                    <a *ngIf="showPickStandingOrderData" class="link mt-20" (click)="transferDirectDebits()" title=""
                        >בחר איזה הוראות קבע להעביר</a
                    >
                </div>
        </div>

        <div class="terms">
            <p>
                {{ contents.homePage.asterix }}
            </p>
        </div>
    </div>
</div>
